export default "__VITE_ASSET__1475dcbf__"